import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    intervideos: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_INTERVIDEO_SELECT_IDS (store, ids) {
      store.intervideos.selectIds = ids
    },
    REMOVE_INTERVIDEO_SELECT_IDS (store, ids) {
      store.intervideos.selectIds = store.intervideos.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_INTERVIDEO_SELECT_ID (store, id) {
      store.intervideos.selectId = id
    },
    SET_INTERVIDEO_FILTERS (store, filters) {
      store.intervideos.filters = filters
    },
    SET_INTERVIDEO_PAGINATE (store, val) {
      store.intervideos.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getIntervideos: (store, getters) => {
      return store.intervideos.selectIds.map((id) => {
        return getters['entities/intervideos/find'](id)
      })
    },
    getIntervideosFilters: (store, getters) => {
      return store.intervideos.filters
    },
    getIntervideosPaginate: (store, getters) => {
      return store.intervideos.paginate
    },
    getIntervideo: (store, getters) => {
      return getters['entities/intervideos/find'](store.intervideos.selectId) || {}
    }
  },
  actions: {
    /*
    selectIntervideos
    */
    selectIntervideos ({commit, dispatch, getters, state}, filters) {
      return dispatch('getIntervideos', filters)
      .then((response) => {
        commit('SET_INTERVIDEO_FILTERS', filters)
        commit('SET_INTERVIDEO_PAGINATE', response)
        commit('SET_INTERVIDEO_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectIntervideos
    */
    refreshSelectIntervideos ({commit, dispatch, getters, state}) {
      return dispatch('selectIntervideos', getters.getIntervideosFilters)
    },
    /*
    selectIntervideo
    */
    selectIntervideo ({commit, dispatch, getters, state}, id) {
      return dispatch('getIntervideoById', id)
      .then((response) => {
        commit('SET_INTERVIDEO_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getIntervideos
    */
    getIntervideos ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/intervideos`, {params: filters})
      .then((response) => {
        return dispatch('entities/intervideos/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.intervideos || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getIntervideoById
    */
    getIntervideoById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/intervideos/${id}`)
      .then((response) => {
        return dispatch('entities/intervideos/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.intervideos[0]
      })
    },
    /*
    createIntervideo
    */
    createIntervideo ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/intervideos`, data)
      .then((response) => {
        return dispatch('entities/intervideos/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.intervideos[0]
      })
    },
    /*
    updateIntervideo
    */
    updateIntervideo ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/intervideos/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/intervideos/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.intervideos[0]
      })
    },
    /*
    deleteIntervideo
    */
    deleteIntervideo ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/intervideos/${id}`)
      .then((response) => {
        commit('REMOVE_INTERVIDEO_SELECT_IDS', [id])
        dispatch('entities/intervideos/delete', id)
        return {}
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Intervideo.js